export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar dirección"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese dirección"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Realizar verificación"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riesgo bajo"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riesgo medio"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riesgo alto"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No está en lista negra"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar otra dirección"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atrás"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione proveedor"])}
}